import type { FC } from 'react';
import { StudioSection } from '../../types/store';
import BlankSlateLayout from './layouts/BlankSlateLayout';
import DefaultLayout from './layouts/DefaultLayout';
import StashLayout from './layouts/StashLayout';
import PlaygroundLayout from './layouts/PlaygroundLayout';
import DraftsLayout from './layouts/DraftsLayout';
import PublishedLayout from './layouts/PublishedLayout';
import BookmarksLayout from './layouts/BookmarksLayout';
import ProductsLayout from './layouts/ProductsLayout';
import PremiumGalleriesLayout from './layouts/PremiumGalleriesLayout';
import AppsLayout from './layouts/AppsLayout';

export interface Props {
  activeSection: StudioSection;
  hasDeviations?: boolean;
  isProductsSection?: boolean;
}

const StudioTableMobile: FC<Props> = ({
  activeSection,
  hasDeviations,
  isProductsSection,
  ...props
}) => {
  // Products catalog
  if (activeSection === StudioSection.PRODUCTS_PREMIUM_GALLERY) {
    return <PremiumGalleriesLayout />;
  } else if (isProductsSection) {
    return <ProductsLayout activeSection={activeSection} />;
  }

  // Other sections
  switch (activeSection) {
    case StudioSection.STASH:
      return <StashLayout {...props} />;
    case StudioSection.PLAYGROUND:
      if (!hasDeviations) {
        return <BlankSlateLayout />;
      }
      return <PlaygroundLayout {...props} />;
    case StudioSection.DRAFTS:
    case StudioSection.LITERATURE:
    case StudioSection.JOURNALS:
      return <DraftsLayout {...props} />;
    case StudioSection.PUBLISHED:
    case StudioSection.PUBLISHED_GALLERIES:
    case StudioSection.PUBLISHED_TIERS:
      return <PublishedLayout {...props} />;
    case StudioSection.BOOKMARKS:
      return <BookmarksLayout {...props} />;
    case StudioSection.APPS:
    case StudioSection.APPS_UNLISTED:
      return <AppsLayout {...props} />;
    default:
      if (!hasDeviations) {
        return <BlankSlateLayout />;
      }
      return <DefaultLayout {...props} />;
  }
};
StudioTableMobile.displayName = 'StudioTableMobile';

export default StudioTableMobile;
